import React, { Component, Fragment } from "react";
import NomeUnidade from "../../../../UI/NomeUnidade";
import "../../../styleSTI.css";
import MenuSTI from "../../Elementos/MenuSTI";
import api from "../../../../../services/api";
import TabelaPortfolio from "../TabelaPortfolio";
import swal from 'sweetalert';
import utils from "../../../utils/utils";
import utilsGraficos from "../../../../../utils/utilsGraficos"
import Select from "../../Elementos/Select";

export default class PortFolio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Dashboard",
            unidades: "Todas",
            linhas: "Todas"
        }
    }

    async componentDidMount() {
        this.consultaMetas();
    }

    consultaMetas = async (unidade, filtro) => {
        let metas;
        if(unidade === undefined || unidade === "Todas") {
            metas = await api.get(`/sti/metas`);
        }
        else {
            metas = await api.get(`/sti/metas?unidade=${unidade}`);
        }
        metas = metas.data.metas

        metas = utilsGraficos.filtrar(metas, filtro);
        this.setState({ 
            metas: metas, 
            unidades: unidade, 
            linhas: filtro && filtro.hasOwnProperty("linhaAtuacao") ? filtro.linhaAtuacao : "Todas"
        });
    }

    exibeMetaSweetAlert = async (id) => {
        let detalheProduto = await api.get(`/sti/metas/${id}`);
        detalheProduto = detalheProduto.data.metas;

        let detalhe = utils.exibeDetalhe(detalheProduto);
        swal({
            content: {
                element: 'div',
                attributes: {
                    innerHTML: `${detalhe}`,
                },
            },
            showConfirmButton: true,
            html: true,
            width: '100px',
            customClass: 'swal-wide'
        });
    }

    select = async (event) => {
        let unidade = this.state.unidades;

        let filtro = { 
            linhaAtuacao: this.state.linhas
        }

        switch(event.target.name) {
            case "Sigla":
                unidade = event.target.value;
                break;
            case "linhaAtuacao":
                filtro[event.target.name] = event.target.value
                break;
        }
        
        if(filtro.linhaAtuacao === "Todas") delete filtro.linhaAtuacao;

        await this.consultaMetas(unidade, filtro);
    }
    
    render() {
        return(
            <Fragment>
                <div className="content">
                    <NomeUnidade unidade={"Relatórios STI"} />
                    <div className="row">
                        <div className="col-md-12 ml-auto mr-auto">
                            <MenuSTI />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <Select select={this.select} option={"unidades"} atributo={"Sigla"} />
                        </div>
                        <div className="col-md-6">
                            <Select select={this.select} option={"linhas"} atributo={"linhaAtuacao"} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card ">
                                <div className="card-header ">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5 className="card-title">Geral Total</h5>
                                            <h6>Soluções em Tecnologia e Inovação - STI</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body ">
                                    <div>
                                        <TabelaPortfolio 
                                            {...this.state}
                                            excluirMeta = {this.excluirMeta}
                                            metas = {this.state.metas}
                                            unidade = {this.props.unidade}
                                            exibeFichaSweetAlert={this.exibeMetaSweetAlert}
                                        />
                                    </div>
                                </div>
                                <div className="card-footer ">
                                    <hr />
                                    <div className="stats">
                                        <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                        <span style={{ float: 'right' }}>
                                            <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }}>
                                                Visão Unidades
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Fragment>
        )
    }
}